import { TableProps } from 'antd/es/table';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'REQUEST NO.',
    dataIndex: 'requestId',
    key: 'requestId',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'REQUEST TYPE',
    dataIndex: 'requestTypeId',
    key: 'requestTypeId',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'EMPLOYEE NAME',
    dataIndex: 'employeeName',
    key: 'employeeName',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'EMPLOYEE OCCUPATION',
    dataIndex: 'employeeOccupation',
    key: 'occupation',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'COMPANY',
    dataIndex: 'company',
    key: 'companyName',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'DATE & TIME CREATED',
    dataIndex: 'created',
    key: 'created',
    ellipsis: true,
    sorter: true,
  },
  {
    title: 'LAST UPDATE',
    dataIndex: 'lastUpdated',
    key: 'updated',
    ellipsis: true,
    sorter: true,
  },
];
